import React from "react";
import ErrorBoundary from "../mui/error_boundary/ErrorBoundary";
import Header from "./header/Header";
import Banners from "./banners/Banners";
import FindGameLine from "./find_game_line/FindGameLine";
import CatalogGame from "./catalog_game/CatalogGame";
import Favorites from "./favorites/Favorites";
import Jackpot from "./jackpot/Jackpot";
import LoaderContainer from "../mui/loader_container/LoaderContainer";
import Footer from "./footer/Footer";
import { useAppSelector } from "../../store/index.ts";

export default function LandingContent() {
  const loading = useAppSelector((state) => state.games.categoryLoading);

  return (
    <>
      <ErrorBoundary>
        <Header />
      </ErrorBoundary>
      <ErrorBoundary>
        <Banners />
      </ErrorBoundary>
      <ErrorBoundary>
        <Jackpot />
      </ErrorBoundary>
      <ErrorBoundary>
        <FindGameLine inputId={"main__find-fame"} hideLobby />
      </ErrorBoundary>
      <LoaderContainer loader={loading} center fullHeight>
        <ErrorBoundary>
          <CatalogGame />
        </ErrorBoundary>
        <ErrorBoundary>
          <Favorites />
        </ErrorBoundary>
      </LoaderContainer>
      <ErrorBoundary>
        <Footer />
      </ErrorBoundary>
    </>
  );
}
